import Slider from "react-slick";

export default function LandingGallery() {
    const settings = {
    dots: false,
    arrows: false,
    slidesToShow: 3,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    speed: 9000,
    remove: true,
    responsive: [
        {
            breakpoint: 991,
            settings: { slidesToShow: 2,},
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
    ],
    };


    const settings2 = {
    dots: false,
    arrows: false,
    slidesToShow: 3,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    speed: 9000,
    remove: true,
    rtl: true, 
    responsive: [
        {
            breakpoint: 991,
            settings: { slidesToShow: 2,},
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
    ],
    };

  return (
    <>
    <section className="landpage-gallery">
        <Slider className="landgallery-slider" {...settings}>
            <div><img src="/image/landgallery-1.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-2.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-3.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-4.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
        </Slider> 

        <Slider className="landgallery-slider" {...settings2}>
            <div><img src="/image/landgallery-5.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-6.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-7.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-8.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
        </Slider> 

        <Slider className="landgallery-slider" {...settings}>
            <div><img src="/image/landgallery-9.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-10.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-11.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
            <div><img src="/image/landgallery-12.webp" loading="lazy" className="img-responsive" alt="gallery"/></div>
        </Slider> 
     </section>
    </>
  )
}
